import { useNavigate } from "react-router-dom";

import { Button } from "@/components/Button/Button";
import { PaytrieTopIcon, LoginHeader } from "@/components/widget-components";
import { Stepper } from "@/pages/Signup/Stepper/Stepper";

export const CompleteRegistration = () => {
  const navigate = useNavigate();

  const returnToHome = () => {
    navigate("/EasyLogin");
  };

  return (
    <div className="flex flex-col md:flex-row" data-testid="container-registration-container">
      <LoginHeader>
        <Stepper />
      </LoginHeader>
      <div className="relative p-5 lg:py-20 w-full">
        <PaytrieTopIcon className="absolute top-5 right-5 hidden md:block" data-testid="container-logo" />
        <div className="flex-grow mb-5">
          <div className="flex flex-col gap-5">
            <div className="text-2xl font-normal uppercase" data-testid="container-message">
              Welcome to Paytrie!
            </div>
            {/* IMPROVEMENT: Consider wrapping verification message in a dedicated component with proper semantic HTML (e.g., <p>) instead of <span> and <br> tags for better structure and accessibility. */}
            <br />
            <span data-testid="container-message">Your account has been verified.</span>
            <br />
            <br />
            <br />
            {/* IMPROVEMENT: Add a loading state to the button to provide visual feedback while navigation is occurring. */}
            {/* IMPROVEMENT: Consider adding a more descriptive success message that guides the user on what to do next (e.g., "You can now explore your dashboard."). */}
            <Button onClick={returnToHome} data-testid="container-to-dashboard-button">CONTINUE TO DASHBOARD</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
